<template>
  <div>
    <h2>
      Вебинары
    </h2>
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit(getWebinars($event))"
          class="form validate"
      >
        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="student"
          >
            <b-form-group
                :label="$t('Выберите ученика')"
                label-for="student"
            >
              <v-select
                  name="student"
                  :options="students"
                  label="name"
                  v-model="studentId"
                  :reduce="model => model.id"
              >
              </v-select>
            </b-form-group>

            <div class="select-wrapper">
              <validation-provider
                  v-slot="validationContext"
                  name="teacher"
              >
                <b-form-group
                    :label="$t('Выберите учителя')"
                    label-for="teacher"
                >
                  <v-select
                      name="teacher_id"
                      :options="teachers"
                      label="name"
                      v-model="teacherId"
                      :reduce="model => model.id"
                  >
                  </v-select>
                </b-form-group>
              </validation-provider>
            </div>

            <b-button type="submit" variant="primary"> {{ $t('Создать пробный урок') }}</b-button>

          </validation-provider>
        </div>
      </b-form>
    </validation-observer>
    <div class="mt-5">
      <vue-good-table
          v-if="webinars.length"
          :columns="columns"
          :rows="webinars"
          :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
          :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      >
        <template
            slot="table-row"
            slot-scope="props"
        >

          <!-- Column: Name -->
          <div
              v-if="props.column.field === 'scheduled_date'"
              class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.scheduled_date }} {{props.row.scheduled_time}}</span>
          </div>
          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'is_past'">
          <b-badge v-if="props.row.is_past === 0">
            Назначен
          </b-badge>
           <b-badge variant="warning" v-if="props.row.is_past === 1">
            В процессе
          </b-badge>
           <b-badge variant="success" v-if="props.row.is_past === 2">
            Завершен
          </b-badge>
           <b-badge variant="danger" v-if="props.row.is_past === 3">
            Отменен
          </b-badge>
        </span>

          <!-- Column: Common -->
          <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
              <b-form-select
                  v-model="pageLength"
                  :options="['3','5','10']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap "> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>

import {BButton, BForm, BFormGroup, BFormSelect, BPagination, BBadge} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import vSelect from 'vue-select'
import {createNamespacedHelpers} from 'vuex';
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import formattedDate from '@/mixins/formattedDate'
import CRMApi from '@/api/crm'

const {mapState, mapActions} = createNamespacedHelpers('crm')

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormSelect,
    BForm,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    BButton,
    BFormGroup,
    BBadge
  },
  mixins: [formattedDate],
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Дата',
          field: 'scheduled_date',
        },
        {
          label: 'Статус',
          field: 'is_past'
        },
      ],
      rows: [],
      searchTerm: '',
      webinars: [],
      studentId: '',
      teacherId: '',
    }
  },
  computed: {
    ...mapState({
      teachers: state => state.teachers,
      students: state => state.students,
    })
  },
  methods: {
    ...mapActions(['getUsers']),
    getWebinars() {
      CRMApi.getWebinars({
        teacherId: this.teacherId,
        studentId: this.studentId
      })
          .then(res => {
            this.webinars = res.data
          })
          .catch(err => {
            console.log(err)
          })
    }
  },
  created() {
    this.getUsers();
  }
}
</script>

<style scoped>

</style>
